import React, { useState } from 'react';
import { Card, CardBody, Button, Table } from 'reactstrap';

// Tarih formatlama yardımcı fonksiyonu
const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    try {
        let date;
        if (dateString.includes('T')) {
            date = new Date(dateString);
        } else if (dateString.includes('/')) {
            const [month, day, year] = dateString.split('/');
            date = new Date(year, month - 1, day);
        } else {
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            console.warn('Invalid date:', dateString);
            return '-';
        }

        return date.toLocaleDateString('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch (error) {
        console.error('Date formatting error:', error);
        return '-';
    }
};

// Version notundan durum değişikliğini çıkaran fonksiyon
const extractStatusFromNote = (note) => {
    if (!note) return null;
    const statusMatch = note.match(/Durum değişikliği: (\w+) -> (\w+)/);
    return statusMatch ? statusMatch[2] : null;
};

const getStatusBadgeColor = (status) => {
    switch (status) {
        case 'Taslak':
            return 'secondary';
        case 'Beklemede':
            return 'warning';
        case 'Onaylandı':
            return 'success';
        case 'Reddedildi':
            return 'danger';
        case 'İptal Edildi':
            return 'dark';
        default:
            return 'info';
    }
};

const VersionHistoryTable = ({ versionHistory, onRefresh }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleManualRefresh = async () => {
        setIsLoading(true);
        try {
            await onRefresh();
        } catch (error) {
            console.error('Refresh error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getVersionStatus = (version) => {
        // Versiyon notundan durum değişikliğini kontrol et
        const statusFromNote = extractStatusFromNote(version.version_note);
        // Eğer not içinde durum değişikliği varsa onu kullan, yoksa mevcut durumu kullan
        return statusFromNote || version.status || 'Taslak';
    };

    return (
        <Card>
            <CardBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="mb-0">Versiyon Geçmişi</h5>
                    <Button
                        color="light"
                        size="sm"
                        onClick={handleManualRefresh}
                        disabled={isLoading}
                    >
                        <i className={`ri-refresh-line ${isLoading ? 'rotate-animation' : ''}`}></i>
                        {isLoading ? 'Yenileniyor...' : 'Yenile'}
                    </Button>
                </div>
                <div className="table-responsive">
                    <Table className="table-bordered table-striped mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: "10%" }}>Versiyon</th>
                                <th style={{ width: "15%" }}>Teklif No</th>
                                <th style={{ width: "10%" }}>Durum</th>
                                <th>Versiyon Notu</th>
                                <th style={{ width: "15%" }}>Teklif Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versionHistory && versionHistory
                                .sort((a, b) => b.version - a.version)
                                .map((version, index) => {
                                    const status = getVersionStatus(version);
                                    return (
                                        <tr key={version.id || index}>
                                            <td className="text-center">V{version.version}</td>
                                            <td>{version.invoice_number}</td>
                                            <td>
                                                <span className={`badge bg-${getStatusBadgeColor(status)}`}>
                                                    {status}
                                                </span>
                                            </td>
                                            <td>{version.version_note || '-'}</td>
                                            <td>{formatDate(version.exchange_rate_date || version.created)}</td>
                                        </tr>
                                    );
                                })}
                            {(!versionHistory || versionHistory.length === 0) && (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        Versiyon geçmişi bulunamadı
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default VersionHistoryTable;